window.addPoiToBucketlist = async (item) => {
    const list = document.getElementById('bucket-list');

    if (!window.bucketItemIsValid(item)) {
        toastr.error("Une erreur est survenu.");
    }

    list.insertAdjacentHTML(
        "afterbegin",
        window.getBucketItemTemplate(item)
    );

    await window.updateUserBucketList({
        'action': 'add',
        'poi_id': item.id
    })
        .then((res) => res.json())
        .then((res) => {
            toastr.success('Votre bucket list à bien été mis à jour');
        })
        .catch((error) => {
            toastr.error('Une erreur est survenu')
        });

    window.openPanel('panel-bucketlist');
}

window.removePoiFromBucketlist = async (item) => {
    const list = document.getElementById('bucket-list');
    const bucketEl = list.querySelector("[data-bucket-id='" + item.id + "']");

    if (bucketEl) {
        bucketEl.remove();
    }

    await window.updateUserBucketList({
        'action': 'remove',
        'poi_id': item.id
    })
        .then((res) => res.json())
        .then((res) => {
            toastr.success('Votre bucket list à bien été mis à jour');
        })
        .catch((error) => {
            toastr.error('Une erreur est survenu')
        });
    window.openPanel('panel-bucketlist');
}

// session storage manager
window.addEventListener('storage', async (e) => {
    if (e.key === 'map_session') {
        const sessionVal = JSON.parse(e.newValue);
        const list = document.getElementById('bucket-list');

        if (sessionVal.bucketlist.id) {
            if (!window.bucketItemIsValid(sessionVal['bucketlist'])) {
                toastr.error("Une erreur est survenu.");
            }

            list.insertAdjacentHTML(
                "afterbegin",
                window.getBucketItemTemplate(sessionVal.bucketlist)
            );
        } else if (sessionVal.removeBucketlist.id) {
            const bucketEl = list.querySelector("[data-bucket-id='" + sessionVal.removeBucketlist.id + "']");

            if (bucketEl) {
                bucketEl.remove();
            }
        }

        localStorage.setItem('map_session', JSON.stringify({
            bucketlist: [],
            removeBucketlist: []
        }));

        window.openPanel('panel-bucketlist');
    }
});